export const SET_SAVE_userInfo = "SET_SAVE_userInfo";

export const SET_SAVE_lang = "SET_SAVE_lang";

export const SET_SAVE_sideBarList = "SET_SAVE_sideBarList";

export const SET_SAVE_sideBarListCN = "SET_SAVE_sideBarListCN";

export const SET_SAVE_sideBarListEN = "SET_SAVE_sideBarListEN";
